const trim = str => str.replace(/^\s+|\s+$/g, '');

export default trim;
